import React, { Component } from 'react';
import { Radio } from 'antd';
import './AirRadio.css';
export default class AirRadio extends Component {
  render() {
    const className = `AirRadio${!!this.props.checked ? ' AirRadioChecked' : ''}`;
    return (
      <div className={className}>
        {/*<div className="label">{this.props.label}</div>*/}
        <div className="control">
          <Radio value={this.props.value} checked={this.props.checked} className="control-wrap">
            <div className="control-label">{this.props.label}</div>
            <div className="control-radio"><span className="checkmark" /></div>
          </Radio>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirRadio/AirRadio.js